<div class="align-left">
  <div class="flex flex--column-reverse">
    @if (!hideTitle()) {
      <div class="flex flex--middle ms-medium-b">
        @if (useH1()) {
          <h1 class="font-title-medium">{{ titleText() }}</h1>
        } @else {
          <h4 tabindex="0">Location and language</h4>
        }
      </div>
    }
    <div class="flex flex--align-start" [class.flex--space-between]="!hideTitle()" [class.flex--end]="hideTitle()">
      @if (!useH1() && !hideTitle()) {
        <fcom-icon class="icon-medium ms-xsmall-r flex--self-center" [name]="SvgLibraryIcon.LANGUAGE" />
      }
      @if (showCloseButton()) {
        <fcom-icon-button
          [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
          [theme]="IconButtonTheme.TERTIARY_GHOST"
          [size]="IconButtonSize.MEDIUM"
          [aria]="{ label: 'Close' }"
          (clickBtn)="emitClose()"
          data-testid="country-selector-close-button"
        />
      }
    </div>
  </div>
  <div class="relative" [ngClass]="{ 'show-flag': showFlag() }">
    @if (showFlag()) {
      <span class="flag flag-{{ formGroup.controls.country.value | lowercase }} absolute ms-small-l z1"></span>
    }
    <fcom-combo-box
      [id]="'select-country'"
      [label]="'Location'"
      [parentForm]="formGroup"
      [controlName]="'country'"
      [translationPrefix]="'countryLanguageSelectorEnOnly'"
      [options]="countryOptions"
      [searchable]="true"
      [selectLabel]="countrySelectLabel()"
      [searchLabel]="'Select or start typing'"
      [clearSearchLabel]="'Clear search'"
      [optionTemplate]="countryOptionTemplate"
      [infoText]="countryShopInfo()"
      finFocus
      [autofocus]="true"
      (dropDownOpen)="updateShowFlag($event)"
      data-testid="country-selector"
    />
  </div>

  @if (!hideLanguageOptions()) {
    <div>
      <fcom-combo-box
        [id]="'select-language'"
        [label]="'Language'"
        [selectLabelTranslationKey]="'countryLanguageSelectorEnOnly.selectLabel'"
        [parentForm]="formGroup"
        [controlName]="'language'"
        [translationPrefix]="'countryLanguageSelectorEnOnly'"
        [options]="languageOptions$ | async"
        [selectLabel]="languageSelectLabel()"
        [disableSelectOption]="(languageOptions$ | async) === undefined"
        [warningText]="countryShopWarning()"
        data-testid="language-selector"
      />
    </div>
  }

  <div [class.submit-inline]="!fullWidthSubmit()">
    <fcom-button
      [disabled]="!formGroup.valid"
      [mode]="fullWidthSubmit() ? ButtonMode.FILL : ButtonMode.INLINE"
      (clickBtn)="apply()"
      [text]="applyButtonText()"
      [theme]="ButtonTheme.PRIMARY_ACCENT"
      data-testid="apply-button"
    />
  </div>
</div>

<ng-template #countryOptionTemplate let-name="name" let-value="value">
  <span class="flex ps-small fill"
    ><span class="flag flag-{{ value | lowercase }} mr-xsmall-r"></span><span>{{ name }}</span></span
  >
</ng-template>
